import RecruitTasks from "../components/Recruiting/RecruitTasks";
import {PERM} from "../utilites/permissions";

const recruitTasks = [
  {
    path: '/recruit_tasks/:id(\\d+)?',
    name: 'RecruitTasks',
    component: RecruitTasks,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.RECRUIT_TASK
      ]
    },
    props: true,
  },
];

export default recruitTasks;



// WEBPACK FOOTER //
// ./src/router/recruitTasks.js